import axios from '../config/axios';

const API_URL = '/amendment-versions';

const amendmentVersionService = {
  // Create a new amendment version
  createAmendmentVersion: async (amendmentData) => {
    try {
      const response = await axios.post(`${API_URL}/create`, amendmentData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get all amendment versions for a project
  getAmendmentVersions: async (projectId, documentType = 'PROTOCOL') => {
    try {
      const response = await axios.get(`${API_URL}/versions`, {
        params: { projectId, documentType }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get the latest amendment version
  getLatestAmendmentVersion: async (projectId, documentType = 'PROTOCOL') => {
    try {
      const response = await axios.get(`${API_URL}/latest`, {
        params: { projectId, documentType }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get a specific amendment version
  getAmendmentVersion: async (projectId, documentType, versionNumber) => {
    try {
      const response = await axios.get(`${API_URL}/${projectId}/${documentType}/${versionNumber}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update amendment version status
  updateAmendmentStatus: async (projectId, documentType, versionNumber, status, comments = '') => {
    try {
      const response = await axios.put(`${API_URL}/${projectId}/${documentType}/${versionNumber}/status`, {
        status,
        comments
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Create amendment from current changes
  createAmendmentFromChanges: async (projectId, documentType, currentSections, originalSections) => {
    try {
      console.log('Creating amendment from changes for project:', projectId, 'documentType:', documentType);
      console.log('Current sections count:', currentSections.length);
      console.log('Original sections count:', originalSections.length);
      
      const response = await axios.post(`${API_URL}/create-from-changes`, {
        projectId,
        documentType,
        currentSections,
        originalSections
      });
      
      console.log('Amendment creation response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error creating amendment from changes:', error);
      throw error.response?.data || error.message;
    }
  },

  // Get amendment history
  getAmendmentHistory: async (projectId, documentType = 'PROTOCOL') => {
    try {
      console.log('Fetching amendment history for project:', projectId, 'documentType:', documentType);
      const response = await axios.get(`${API_URL}/history`, {
        params: { projectId, documentType }
      });
      console.log('Amendment history response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching amendment history:', error);
      throw error.response?.data || error.message;
    }
  }
};

export default amendmentVersionService; 